module.exports = __webpack_public_path__ + "static/dots-3c68eff3c5ec49f3e28275d86075ce55.png";